import type { CoinType } from '../../../stores/cointype/CoinTypeStore';

const style = window.getComputedStyle(document.body);
const sweepstakeTabColor = style.getPropertyValue('--color-sweep');
const sweepstakeSecondaryTabColor = style.getPropertyValue('--dark-color-sweep');
const socialTabColor = style.getPropertyValue('--color-social');
const socialSecondaryTabColor = style.getPropertyValue('--dark-color-social');

export const getFooterColors = (coinType: CoinType) => {
  const isSweepstake = coinType === 'SC';
  const mainColor = isSweepstake ? sweepstakeTabColor : socialTabColor;
  const secondaryColor = isSweepstake ? sweepstakeSecondaryTabColor : socialSecondaryTabColor;

  return { mainColor, secondaryColor };
};
